/**
 * Field Name Mappings
 * Maps frontend camelCase field names to backend snake_case equivalents
 *
 * CRITICAL: Backend uses snake_case, frontend uses camelCase
 * This file maintains the single source of truth for field name mappings.
 */

import type { CustomerSortField } from '../types/customer';

/**
 * Map frontend camelCase sort fields to backend snake_case
 */
export const SORT_FIELD_MAPPING: Record<CustomerSortField, string> = {
  name: 'name',
  createdAt: 'created_at',
  truckCount: 'truck_count',
  trucksDueWithin2Weeks: 'trucks_due_within_2_weeks',
  trucksDueWithin2To6Weeks: 'trucks_due_within_2_6_weeks',
  trucksDueWithin6To12Weeks: 'trucks_due_within_6_12_weeks',
};

/**
 * Convert frontend sort field to backend format
 */
export function mapSortFieldToBackend(field: CustomerSortField): string {
  return SORT_FIELD_MAPPING[field] || field;
}
